import styled from '@emotion/styled'
import { Skeleton } from '@mui/material'
import React from 'react'

import { LoadWhenInView } from '@js/common/components/LoadWhenInView'

interface VendorCoverImageProps {
  coverImage: string
}

export const ImageWrapper = styled.div`
  position: relative;
  margin: ${({ theme }) => theme.spacing(0, -2, 0, -2)};

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin: ${({ theme }) => theme.spacing(0, 0, 2, 0)};
  }
`

const VendorImage = styled.img`
  height: 220px;
  object-fit: cover;
`

export const VendorCoverImage = ({ coverImage }: VendorCoverImageProps) => {
  return (
    <ImageWrapper>
      <LoadWhenInView
        Placeholder={() => (
          <Skeleton variant='rectangular' width='100%' height={220} />
        )}>
        <VendorImage src={coverImage} alt='vendor-image' />
      </LoadWhenInView>
    </ImageWrapper>
  )
}
